// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.well {
    border: solid 1px #d3d3d3;
    background-color: #f5f5f5;
    padding: 15px 20px;
    border-radius: 4px;
    margin-bottom: 15px;
}

.form-group {
    margin-bottom: 12px;
}

.form-group label,
.form-group .control-label {
    display: block;
    font-weight: bold;
    margin-bottom: 4px;
}

.form-group br {
    display: none;
}

.btn-row {
    margin-top: 8px;
    padding-bottom: 5px;
}

.btn-row button + button {
    margin-left: 8px;
}

`, "",{"version":3,"sources":["webpack://./src/app/utilities/invoice-upload/invoice-upload.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".well {\r\n    border: solid 1px #d3d3d3;\r\n    background-color: #f5f5f5;\r\n    padding: 15px 20px;\r\n    border-radius: 4px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.form-group label,\r\n.form-group .control-label {\r\n    display: block;\r\n    font-weight: bold;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.form-group br {\r\n    display: none;\r\n}\r\n\r\n.btn-row {\r\n    margin-top: 8px;\r\n    padding-bottom: 5px;\r\n}\r\n\r\n.btn-row button + button {\r\n    margin-left: 8px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
